import type { Transactable, TransactableEntity } from '@src/domains/transactables/types/transactable';

export const resolveTransactableEntity = (tr: Transactable): TransactableEntity =>
  tr.saleChange ?? tr.order ?? tr.sale ?? tr.directLink;
